
import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";
import { Arrays } from "../../library-js/tools/Arrays";
import { ClassConstructor, getClass, isClassOf } from "../../library-js/tools/TypeUtilities";
import { InspectorContainer } from "./containers/InspectorContainer";
import { InspectorField } from "./fields/InspectorField";
import { Inspector } from "./Inspector";
import { InspectorCreationInfo } from "./InspectorCreationInfo";
import { InspectorCustomClassCreator } from "./InspectorCustomClassCreator";
import { InspectorVisibilityProcessor } from "./InspectorVisibilityProcessor";

export class InspectorLibrary
{
  _customClassCreator = new InspectorCustomClassCreator();

  handles( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element )
  {
    if ( this._customClassCreator.handles( parentInfo, info, parent ) )
    {
      return true;
    }

    return false;
  }
 

  postProcess( inspector:Inspector )
  {
    inspector.fields.forEach(
      ( f ) =>
      {
        let clss = getClass( f.info.object ); 

        if ( ! clss )
        {
          return;
        }

        let processor = clss as any as InspectorVisibilityProcessor;

        if ( ! processor.definesInspectorFieldsVisibilites )
        {
          return;
        }

        processor.definesInspectorFieldsVisibilites( f );
      }
    );

  }

 

}